import React from 'react';

import Block from 'detailsv2/LandingV2/Page/RightSide/Block';
import { useBlockContext } from 'detailsv2/LandingV2/Page/RightSide/Block/context';

import * as types from './types';

const BlockItem = ({
  block,
  spoilerBlockIndex,
  onAddBlock,
  onUpdateBlock,
  onDeleteBlock,
  isInsideAccordion,
}: types.BlockItemProps) => {
  const { index: parentBlockIndex, readonly, config, outerDisabledAddingBlocks } = useBlockContext();

  if (isInsideAccordion && block.type === 'accordion') return null;

  if (block?._destroy) return null;

  return (
    <Block
      readonly={readonly}
      disabledAddingBlocks={config.disabledAddingBlocksForChildren ?? outerDisabledAddingBlocks}
      block={block}
      index={[...parentBlockIndex, spoilerBlockIndex]}
      onAdd={onAddBlock?.(spoilerBlockIndex)}
      onUpdate={onUpdateBlock?.(spoilerBlockIndex)}
      onDelete={onDeleteBlock?.(spoilerBlockIndex)}
      isInsideAccordion={isInsideAccordion}
    />
  );
};

export { BlockItem };
